import React from 'react';
import { fromPairs, isEmpty } from 'ramda';
import { withPrefix } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';
import { renderWhenTrue } from '../../utils/rendering';
import { ELEMENTS_TYPES } from './hero.constants';
import {
  Container,
  Cover,
  Image,
  ImageCaption,
  SectionWrapper,
  SectionName,
  SectionNumber,
  Icon,
  ColombiaIcon,
  MongoliaIcon,
  SeychellesIcon,
  Title,
  Content,
  ContentWrapper,
  ShareButton,
} from './hero.styles';
import ShareModal from '../shareModal/shareModal.component';
import { useWindowLocation } from '../../hooks/useWindowLocation';
import { useShareModal } from '../../hooks/useShareModal';

export const { ICON, IMAGE, IMAGE_CAPTION, INTRO_TEXT, SECTION_NAME, SECTION_NUMBER, TITLE } = ELEMENTS_TYPES;

const renderTitle = (title) => {
  const intl = useIntl();
  return renderWhenTrue(() => <Title>{intl.formatMessage({ id: title })}</Title>)(!!title);
};

const renderContent = (content) => {
  const intl = useIntl();
  return renderWhenTrue(() => <Content>{intl.formatMessage({ id: content })}</Content>)(!!content);
};

const renderCaption = (caption) => {
  const intl = useIntl();
  return renderWhenTrue(() => <ImageCaption>{intl.formatMessage({ id: caption })}</ImageCaption>)(!!caption);
};

const renderCover = (image, caption) =>
  renderWhenTrue(() => (
    <Cover>
      <Image image={withPrefix(image)} />
      {renderCaption(caption)}
    </Cover>
  ))(!!image);

const renderIcon = (icon) => {
  if(icon === '/images/Colombia.png') {
    return renderWhenTrue(() => <ColombiaIcon src={withPrefix(icon)} />)(!!icon);
  } if (icon === '/images/Mongolia.png') {
    return renderWhenTrue(() => <MongoliaIcon src={withPrefix(icon)} />)(!!icon);
  }if (icon === '/images/Seychelles.png') {
    return renderWhenTrue(() => <SeychellesIcon src={withPrefix(icon)} />)(!!icon);
  } else return renderWhenTrue(() => <Icon src={withPrefix(icon)} />)(!!icon);
}

export const Hero = ({ elements = [] }) => {
  const intl = useIntl();
  const shareModalState = useShareModal();
  const windowLocation = useWindowLocation()() || {};
  const getLinkToShare = () =>
    [
      windowLocation.origin,
      `${windowLocation.pathname.replace(/\/$/, '')}/`,
      isEmpty(windowLocation.hash) ? '' : `${windowLocation.hash.replace('#', '')}/`,
    ].join('');

  const items = fromPairs(
    elements.map(({ name, value, url }) => (name === IMAGE || name === ICON ? [name, url] : [name, value]))
  );

  const renderSectionWrapper = (name, number) =>
    renderWhenTrue(() => (
      <SectionWrapper>
        <SectionName>{intl.formatMessage({ id: name })}</SectionName>
        <SectionNumber>{number && intl.formatMessage({ id: number, defaultMessage: '' })}</SectionNumber>
        <ShareButton onClick={shareModalState.onRequestOpen} />
        {shareModalState.isOpen && <ShareModal modalProps={shareModalState} linkToShare={getLinkToShare()} />}
      </SectionWrapper>
    ))(!!(name || number));

  return (
    <Container>
      {renderCover(items[IMAGE], items[IMAGE_CAPTION])}
      <ContentWrapper short={true}>
        {renderIcon(items[ICON])}
        {renderSectionWrapper(items[SECTION_NAME], items[SECTION_NUMBER])}
        {renderTitle(items[TITLE])}
        {renderContent(items[INTRO_TEXT])}
      </ContentWrapper>
    </Container>
  );
};
